// @flow

import * as React from 'react';

import { Cloud } from '../../ice/fields/SimulationContent/Cloud';
import { Ground } from '../../ice/fields/SimulationContent/Ground';
import { Place } from '../../ice/fields/SimulationContent/Place';
import { Sky } from '../../ice/fields/SimulationContent/Sky';
import { Wagon } from './Wagon';
import Uriko from '../../ice/fields/SimulationContent/Uriko';

class Background extends React.PureComponent<{
  colorIndex: number,
  weather: number,
  place: number,
  wagon: number,
  scale: number,
  soldout: boolean,
}> {
  render() {
    return (
      <React.Fragment>
        <Sky colorIndex={this.props.colorIndex} />
        <Cloud weather={this.props.weather} />
        <Ground weather={this.props.weather} />
        <Place place={this.props.place} />
        <Wagon soldout={this.props.soldout} wagon={this.props.wagon} scale={this.props.scale} />
        {!this.props.soldout && <Uriko scale={this.props.scale} />}
      </React.Fragment>
    );
  }
}

export default Background;
